/* ──────────────────────────────────────────────
 *  Écrans hors du parcours de réservation : la réservation est
 *  confirmée (`success`) ou la demande de devis a remplacé le
 *  parcours (`quote`). Les habillages du parcours — récap, pied de
 *  page, bande « paiement sécurisé », mesure des étapes — n'y ont pas
 *  leur place. Même liste que `VisibleBookingStep` (booking-machine) :
 *  la source unique à lire plutôt que de recopier les deux noms.
 * ────────────────────────────────────────────── */

import type { BookingStep } from '../types';

const OUTSIDE_BOOKING_PATH_STEPS: ReadonlySet<string> = new Set<BookingStep>(['success', 'quote']);

export const isOutsideBookingPath = (step: BookingStep | 'loading' | 'error'): boolean =>
  OUTSIDE_BOOKING_PATH_STEPS.has(step);
